module.exports = __webpack_public_path__ + "img/sustainability-officer-img.ab596410.png";